import { Dialog, Typography } from '@mui/material';
import { Box, SystemStyleObject } from '@mui/system';
import React from 'react';

import { LoadingButton } from '@/components/molecules/LoadingButton';
import { ApplicationModal } from '@/components/organisms/ApplicationModal';

interface ConfirmationModalProps {
  readonly open: boolean;
  readonly title: string;
  readonly description?: string;
  readonly confirmButtonText: string;
  readonly abortButtonText: string;
  readonly loading?: boolean;
  readonly width?: number;

  onConfirm(): void;
  onAbort(): void;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = (
  props: ConfirmationModalProps,
): React.ReactElement => {
  const {
    open,
    onConfirm,
    onAbort,
    abortButtonText,
    confirmButtonText,
    title,
    description,
    width = 552,
    loading = false,
  } = props;

  return (
    <Dialog open={open} onClose={onAbort}>
      <ApplicationModal
        title={title}
        description={description}
        variant="prominent"
        width={width}
        onClose={onAbort}>
        <LoadingButton
          variant="contained"
          color="error"
          fullWidth={true}
          loading={loading}
          onClick={onConfirm}>
          {confirmButtonText}
        </LoadingButton>
        <Box component="a" sx={styles.customButton} onClick={onAbort}>
          <Typography variant="body2" color="text.primary">
            {abortButtonText}
          </Typography>
        </Box>
      </ApplicationModal>
    </Dialog>
  );
};

const styles: Record<string, SystemStyleObject> = {
  customButton: {
    display: 'block',
    textAlign: 'center',
    mt: 2,
    cursor: 'pointer',
  },
};
